var _g, _path, _path2, _path3, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsgirl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_608",
    "data-name": "Group 608",
    xmlns: "http://www.w3.org/2000/svg",
    width: 182.724,
    height: 443.882,
    viewBox: "0 0 182.724 443.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_520",
    "data-name": "Group 520",
    transform: "translate(59.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478",
    transform: "translate(37.827 4.838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M598.031,242.058c5.225-8.771,6.749-20.473,8.094-30.6.632-4.763,1.741-11.546-1.6-14.537-3.581-3.2-3.911-8.128-8.029-10.6s-9.714-2.7-13.612.112",
    transform: "translate(-582.88 -184.395)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_504",
    "data-name": "Group 504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_488",
    "data-name": "Group 488",
    transform: "translate(0.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485",
    transform: "translate(9.659 9.654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_484",
    "data-name": "Group 484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    "data-name": "Group 483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_481",
    "data-name": "Group 481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_480",
    "data-name": "Group 480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_479",
    "data-name": "Group 479"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M594.369,271.285h0A14.1,14.1,0,0,1,579.2,257.764c-.295-7.676-.552-15.434-.552-15.434s-11.632-1.091-12.476-12.6-.457-38.086-.457-38.086h0a40.109,40.109,0,0,1,40.537,2.607l-.716,40.512v21.8C605.459,263.868,601.658,270.725,594.369,271.285Z",
    transform: "translate(-565.627 -187.352)",
    fill: "#ffbe9d"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    "data-name": "Group 486"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M581.372,219.4c1.987-2.462,5.215-3.44,7.866-1.718a6.691,6.691,0,0,1,2.231,8.366,8.816,8.816,0,0,1-5.648,4.269,4.422,4.422,0,0,0-3.462,4.761c.332,2.888,5.139,3.975,7.307,6.365,3.374,3.721,10.779,5.3,15.766,5.884,4.9.58,4.312.627,7.164-3.4a15.457,15.457,0,0,0,2.8-9.344q.264-12.732.528-25.463a36.478,36.478,0,0,0-.58-9.136,12.272,12.272,0,0,0-4.82-7.555c-2.8-1.843-6.347-2-9.535-3.032-3.988-1.29-7.373-3.934-11.1-5.842s-8.3-3.048-12.049-1.169c-2.687,1.35-4.489,4.032-7.1,5.52-3.72,2.117-8.788,1.636-10.595,7.107a9.288,9.288,0,0,0,.062,5.854c2.524,7.448,11.748,10.45,18.391,7.231.13,1.262-1.112,4.069.216,8.053.425,1.273.575,3.216,2.565,3.252",
    transform: "translate(-559.695 -181.423)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491",
    transform: "translate(23.769 39.568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    "data-name": "Group 490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_489",
    "data-name": "Group 489"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M574.29,211.318c.088-.073.48.609,1.439.549a2.677,2.677,0,0,0,2.153-2.628,2.88,2.88,0,0,0-1.977-2.864c-.946-.35-1.627-.171-1.656-.3-.05-.078.633-.519,1.822-.272a3.44,3.44,0,0,1,1.807,1.039,3.333,3.333,0,0,1,.85,2.444,3.178,3.178,0,0,1-3,3.185,1.723,1.723,0,0,1-1.286-.646C574.241,211.538,574.242,211.336,574.29,211.318Z",
    transform: "translate(-574.246 -205.724)",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494",
    transform: "translate(35.791 8.033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M581.632,188.779c-.028-.024.251-.441.966-.975a7.706,7.706,0,0,1,3.5-1.36,10.078,10.078,0,0,1,5.51.839,12.63,12.63,0,0,1,5.078,4.54c2.7,4.115,3.214,8.612,3.574,11.657a30.036,30.036,0,0,1,.3,5.026,29.349,29.349,0,0,1-.9-4.95c-.5-3.017-1.117-7.369-3.685-11.263a12.3,12.3,0,0,0-4.707-4.3,9.246,9.246,0,0,0-9.638.79Z",
    transform: "translate(-581.63 -186.356)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497",
    transform: "translate(0 5.605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M563.026,201.489c0,.026-.158.031-.438-.033a3.3,3.3,0,0,1-1.146-.516,4.144,4.144,0,0,1-1.337-1.5,3.824,3.824,0,0,1-.36-2.664,4.377,4.377,0,0,1,1.866-2.688,6.258,6.258,0,0,1,3.641-.713,5.041,5.041,0,0,0,3.476-.879,25.5,25.5,0,0,0,2.814-3.035,14.352,14.352,0,0,1,7.167-4.137,15.27,15.27,0,0,1,6.754-.15,13.089,13.089,0,0,1,4.245,1.63,4.932,4.932,0,0,1,1.316,1.016c-.09.179-1.964-1.439-5.668-2.056a15.368,15.368,0,0,0-6.454.318,13.941,13.941,0,0,0-6.736,3.953,23.9,23.9,0,0,1-2.941,3.126,4.719,4.719,0,0,1-1.982.891,9.627,9.627,0,0,1-2,.106,5.674,5.674,0,0,0-3.257.526,3.8,3.8,0,0,0-1.657,2.234,3.706,3.706,0,0,0,1.311,3.761A8.873,8.873,0,0,0,563.026,201.489Z",
    transform: "translate(-559.648 -184.865)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500",
    transform: "translate(23.74 18.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    "data-name": "Group 499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M584.665,228.642c-.029-.07.58-.285,1.519-.918a9.512,9.512,0,0,0,3.139-3.5,8.864,8.864,0,0,0-1.562-10.207,16.674,16.674,0,0,0-3.6-2.631c-1.345-.782-2.713-1.508-3.963-2.359a13.385,13.385,0,0,1-3.186-3,13.9,13.9,0,0,1-2.693-6.814,12.609,12.609,0,0,1,.375-4.917,7.477,7.477,0,0,1,.461-1.26c.127-.278.207-.417.234-.407a17.083,17.083,0,0,0-.475,6.506,13.749,13.749,0,0,0,2.718,6.415,12.876,12.876,0,0,0,3.035,2.792c1.2.809,2.553,1.519,3.924,2.315a17,17,0,0,1,3.766,2.783,9.346,9.346,0,0,1,2.24,3.805,9.166,9.166,0,0,1-4.242,10.763A4.05,4.05,0,0,1,584.665,228.642Z",
    transform: "translate(-574.228 -192.625)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_503",
    "data-name": "Group 503",
    transform: "translate(26.902 17.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_502",
    "data-name": "Group 502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_501",
    "data-name": "Group 501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M603.4,212.145a5.269,5.269,0,0,1-1.483.331,21.483,21.483,0,0,1-4.139.125,25.649,25.649,0,0,1-12.84-4.414c-4.448-3.015-7.527-7.128-8.425-10.6a8.754,8.754,0,0,1-.171-4.172,3.312,3.312,0,0,1,.572-1.418,10.163,10.163,0,0,0,.176,5.42c.987,3.242,4.015,7.143,8.324,10.066A27,27,0,0,0,597.832,212C601.248,212.375,603.386,211.971,603.4,212.145Z",
    transform: "translate(-576.17 -191.999)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506",
    transform: "translate(54.214 22.267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    "data-name": "Group 505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M594.7,202.311c3.991-4.492,9.87-7.524,15.869-7.187s11.85,4.481,13.316,10.308c1.1,4.385-.243,8.959-.812,13.444s-.018,9.732,3.642,12.389c2.206,1.6,5.061,1.894,7.71,2.54s5.479,1.97,6.389,4.54c1.045,2.945-1.1,6.293-3.963,7.539s-6.173.868-9.211.127c1.389,3.3-.318,7.425-3.413,9.227A10.2,10.2,0,0,1,614,254.812a15.27,15.27,0,0,1-6.246-8.465c-1.969,3.465-7.15,4.194-10.47,1.988s-4.75-6.573-4.235-10.525,2.688-7.514,5.3-10.52a26.006,26.006,0,0,0,3.708-4.719,6.016,6.016,0,0,0,.233-5.753c-1.027-1.723-3.694-2.434-5.124-1.029",
    transform: "translate(-592.944 -195.098)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_510",
    "data-name": "Group 510",
    transform: "translate(54.303 25.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    "data-name": "Group 509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    "data-name": "Group 508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M601.588,213.154c.072.064-1.327.747-3.46-.039a8.328,8.328,0,0,1-5.02-6.554,8.58,8.58,0,0,1,.547-4.673,8.908,8.908,0,0,1,2.206-3.125,5.644,5.644,0,0,1,3.027-1.687,26.708,26.708,0,0,0-2.607,2.115,8.529,8.529,0,0,0-2.336,7.238,7.347,7.347,0,0,0,7.643,6.725Z",
    transform: "translate(-592.999 -197.065)",
    fill: "#e8505b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513",
    transform: "translate(9.8 53.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_512",
    "data-name": "Group 512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    "data-name": "Group 511"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M578.24,225.269a5.424,5.424,0,0,1-2.63-.259,14.166,14.166,0,0,1-9.327-8.232,5.429,5.429,0,0,1-.585-2.576,16.966,16.966,0,0,1,1.13,2.327,16.26,16.26,0,0,0,8.96,7.91A16.85,16.85,0,0,1,578.24,225.269Z",
    transform: "translate(-565.667 -214.201)",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_516",
    "data-name": "Group 516",
    transform: "translate(55.704 33.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_515",
    "data-name": "Group 515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_514",
    "data-name": "Group 514"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M604.844,242.447c-.007.028-.2,0-.565-.083a5.633,5.633,0,0,1-1.5-.668,8.192,8.192,0,0,1-3.27-4.974,10.174,10.174,0,0,1-.142-4.185,16.8,16.8,0,0,1,1.519-4.53c1.451-3.037,3.74-5.919,5.432-9.268a16.487,16.487,0,0,0,1.7-5.124,9.912,9.912,0,0,0-6.394-10.672,10.583,10.583,0,0,0-5.7-.355c-1.35.283-2.039.664-2.073.588-.013-.026.15-.132.476-.314a8.038,8.038,0,0,1,1.516-.593,10.21,10.21,0,0,1,12.347,6.163,10.524,10.524,0,0,1,.65,5.289,17.006,17.006,0,0,1-1.768,5.4c-1.755,3.463-4.053,6.309-5.49,9.234-1.488,2.89-2.071,5.854-1.493,8.236a8.148,8.148,0,0,0,2.874,4.838A15.147,15.147,0,0,0,604.844,242.447Z",
    transform: "translate(-593.859 -201.881)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_519",
    "data-name": "Group 519",
    transform: "translate(55.752 31.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_518",
    "data-name": "Group 518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_517",
    "data-name": "Group 517"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M622.2,251.474a2.336,2.336,0,0,1-.726.041,8.025,8.025,0,0,1-2.055-.366,11.57,11.57,0,0,1-6-4.673c-1.908-2.7-2.809-6.7-2.587-10.971.155-4.305,1.413-8.854,2.219-13.632a31.918,31.918,0,0,0,.485-7.01,18.058,18.058,0,0,0-1.475-6.292,11.469,11.469,0,0,0-8.079-6.744,16.809,16.809,0,0,0-7.412.026c-1.734.387-2.654.77-2.682.7a2.308,2.308,0,0,1,.642-.337,14.384,14.384,0,0,1,1.962-.682,16.183,16.183,0,0,1,7.622-.29,12.21,12.21,0,0,1,4.87,2.185,12.429,12.429,0,0,1,3.789,4.818,18.618,18.618,0,0,1,1.592,6.565,32.106,32.106,0,0,1-.477,7.2c-.822,4.851-2.086,9.34-2.275,13.532-.256,4.163.55,7.987,2.306,10.6a11.623,11.623,0,0,0,5.6,4.691A17.781,17.781,0,0,0,622.2,251.474Z",
    transform: "translate(-593.889 -200.916)",
    fill: "#455a64"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M622.862,264.165l-24.517,19.127,10.289,16.892,29.525-21.753Z",
    transform: "translate(-475.401 -129.441)",
    fill: "#ffbe9d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M596,231.147s.119-2.045-5.227-2.34a56.167,56.167,0,0,0-5.943-.2s-2.41-3.082-2.558-4.958,1.145-5.038,1.145-5.038l5.411-.5-1.469-3.675-3.813.265L572.779,216l-4.287,18.857-29.4,54.875a14.167,14.167,0,0,0,5.613,20.628h0c7.6,3.673,17.785-4.124,20.6-12.082l16.269-61.036,5.722-4.469,8.2-1.5",
    transform: "translate(-514.128 -160.68)",
    fill: "#ffbe9d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M531.966,552.023l40.025-230.258-.057-.013c.085-.342.168-.664.252-1l.008-.044,0,0c6.809-27.008,17.31-35.665,17.31-35.665l61.251,3.843c5.207,9.361,5.868,31.821,5.868,31.821.713,2.753-12.941,225.865-12.941,225.865l-20.485-.565L612.092,334.924,552.485,552.9Z",
    transform: "translate(-517.103 -116.323)",
    fill: "#ffbe9d"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571",
    transform: "translate(0 435.689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525",
    transform: "translate(0.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_522",
    "data-name": "Group 522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_521",
    "data-name": "Group 521"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M537.2,451.086l.08-2.081,21.07.609-.182,6.86-1.3.042c-5.8.143-29.489.35-33.324-.845C519.259,454.339,537.2,451.086,537.2,451.086Z",
    transform: "translate(-522.878 -449.005)",
    fill: "#ad5fb5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524",
    transform: "translate(27.685 1.702)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    "data-name": "Group 523"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M539.881,455.46a6.742,6.742,0,0,1,2.805-4.087,7.472,7.472,0,0,1,4.948-1.286l-.166,5.451Z",
    transform: "translate(-539.881 -450.051)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_527",
    "data-name": "Group 527",
    transform: "translate(0 3.958)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_526",
    "data-name": "Group 526"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M528.449,451.436s-6.3,1.508-5.549,2.485,24.7,1.607,35.289,1.026l-.02-.436L530.227,454S529.669,451.517,528.449,451.436Z",
    transform: "translate(-522.838 -451.436)",
    fill: "#ad5fb5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_530",
    "data-name": "Group 530",
    transform: "translate(0.065 6.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_529",
    "data-name": "Group 529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_528",
    "data-name": "Group 528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M558.473,453.676a2.156,2.156,0,0,1-.361.026l-1.037.031c-1.037.015-2.312.033-3.817.052-3.224.024-7.677,0-12.594-.124s-9.367-.332-12.585-.519l-3.809-.247-1.034-.085a1.936,1.936,0,0,1-.358-.046,2.12,2.12,0,0,1,.361,0l1.037.039c1.036.047,2.309.106,3.812.173,3.219.145,7.666.324,12.581.449s9.366.176,12.588.2l3.817.023,1.037.013A2.125,2.125,0,0,1,558.473,453.676Z",
    transform: "translate(-522.878 -452.758)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_533",
    "data-name": "Group 533",
    transform: "translate(5.464 3.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_532",
    "data-name": "Group 532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_531",
    "data-name": "Group 531"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M528.114,454.394a7.531,7.531,0,0,0-.659-1.711,8.256,8.256,0,0,0-1.259-1.391,2.779,2.779,0,0,1,1.479,1.273A2.459,2.459,0,0,1,528.114,454.394Z",
    transform: "translate(-526.194 -451.286)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_536",
    "data-name": "Group 536",
    transform: "translate(12.593 2.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_535",
    "data-name": "Group 535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_534",
    "data-name": "Group 534"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M531.642,452.141c-.06.033-.345-.309-.638-.765s-.48-.853-.42-.887.347.309.638.765S531.7,452.106,531.642,452.141Z",
    transform: "translate(-530.572 -450.486)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_539",
    "data-name": "Group 539",
    transform: "translate(14.105 2.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_538",
    "data-name": "Group 538"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_537",
    "data-name": "Group 537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M532.783,451.453c-.049.049-.373-.166-.726-.477s-.6-.6-.55-.65.375.166.726.479S532.832,451.408,532.783,451.453Z",
    transform: "translate(-531.5 -450.32)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_542",
    "data-name": "Group 542",
    transform: "translate(14.324 1.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_541",
    "data-name": "Group 541"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_540",
    "data-name": "Group 540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M533.828,449.956a5.153,5.153,0,0,1-2.193-.034,5.153,5.153,0,0,1,2.193.034Z",
    transform: "translate(-531.635 -449.819)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_545",
    "data-name": "Group 545",
    transform: "translate(14.438 0.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_543",
    "data-name": "Group 543"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M534.191,449.12a3.3,3.3,0,0,1-2.486.109,7.35,7.35,0,0,1,1.244-.047A7.238,7.238,0,0,1,534.191,449.12Z",
    transform: "translate(-531.705 -449.099)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548",
    transform: "translate(9.084 0.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    "data-name": "Group 547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_546",
    "data-name": "Group 546"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M532.336,451.15a4.193,4.193,0,0,1-1.348-.044,8.31,8.31,0,0,1-1.426-.332,4.066,4.066,0,0,1-.811-.335.686.686,0,0,1-.322-.4.478.478,0,0,1,.22-.5,2.583,2.583,0,0,1,3.037.752,2.142,2.142,0,0,1,.414.848c.047.215.041.337.024.339a3.384,3.384,0,0,0-.581-1.084,2.429,2.429,0,0,0-1.13-.726,2.244,2.244,0,0,0-1.61.059c-.218.143-.142.379.093.516a4.033,4.033,0,0,0,.749.321,9.647,9.647,0,0,0,1.378.373C531.823,451.1,532.338,451.111,532.336,451.15Z",
    transform: "translate(-528.417 -449.325)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_551",
    "data-name": "Group 551",
    transform: "translate(12.504 0.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_550",
    "data-name": "Group 550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    "data-name": "Group 549"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M530.665,451.4a1.168,1.168,0,0,1-.129-.874,1.982,1.982,0,0,1,.4-.905,1.372,1.372,0,0,1,1.141-.609.5.5,0,0,1,.4.589,1.33,1.33,0,0,1-.246.554,3.815,3.815,0,0,1-.661.741,1.993,1.993,0,0,1-.786.488c-.023-.033.275-.218.659-.606a4.472,4.472,0,0,0,.588-.738c.192-.259.334-.731,0-.8a1.224,1.224,0,0,0-.9.508,2,2,0,0,0-.405.806A4.323,4.323,0,0,0,530.665,451.4Z",
    transform: "translate(-530.517 -449.009)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554",
    transform: "translate(27.774 1.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_552",
    "data-name": "Group 552"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M547.516,450.1c-.006.044-.6-.07-1.55.01a7.08,7.08,0,0,0-3.421,1.207,6.351,6.351,0,0,0-2.2,2.721c-.345.827-.392,1.389-.44,1.381a1,1,0,0,1,.011-.392,4.765,4.765,0,0,1,.261-1.045,6.056,6.056,0,0,1,2.213-2.853,6.794,6.794,0,0,1,3.561-1.184,5.857,5.857,0,0,1,1.153.057A1.244,1.244,0,0,1,547.516,450.1Z",
    transform: "translate(-539.895 -449.938)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557",
    transform: "translate(19.038 5.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_556",
    "data-name": "Group 556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M540.662,452.211a18.514,18.514,0,0,1-6.132-.107c.008-.067,1.376.046,3.066.073S540.656,452.143,540.662,452.211Z",
    transform: "translate(-534.53 -452.083)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560",
    transform: "translate(28.652 5.235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M541.062,452.228c.051.049-.119.267-.269.555s-.233.545-.3.541-.1-.311.076-.643S541.02,452.179,541.062,452.228Z",
    transform: "translate(-540.435 -452.22)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_563",
    "data-name": "Group 563",
    transform: "translate(30.066 3.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_562",
    "data-name": "Group 562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_561",
    "data-name": "Group 561"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M542.122,451.153c.047.047-.094.248-.317.446s-.443.321-.492.274.093-.246.316-.445S542.073,451.106,542.122,451.153Z",
    transform: "translate(-541.303 -451.143)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    transform: "translate(31.919 2.61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M543.649,450.729c-.018.065-.3.055-.607.148s-.537.239-.591.194.129-.309.516-.418S543.672,450.668,543.649,450.729Z",
    transform: "translate(-542.441 -450.608)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569",
    transform: "translate(34.076 2.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M544.406,450.488c.023.062-.1.158-.277.217s-.337.055-.36-.007.1-.158.275-.217S544.383,450.427,544.406,450.488Z",
    transform: "translate(-543.766 -450.441)",
    fill: "#ad5fb5"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594",
    transform: "translate(21.879 75.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573",
    transform: "translate(95.408 1.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M594.871,228.679a40.355,40.355,0,0,1,16.211,6.384c19.37,12.554,51.755,39.1,49.069,51.4-2.286,10.466-27.548,23.175-27.548,23.175L616.2,289.9l10.058-5.751L601.527,267.7Z",
    transform: "translate(-594.871 -228.679)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M642.726,269.1l-.8,2.942-2.848,13.607-.7,19.944c14.69,18.915,14.911,34.841,14.911,34.841l-74.2,8.666c.013-14.656,5.36-33.115,5.36-33.115,4.294-7.282,4.087-29.067,3.284-29.862-4.636-4.595-5.759-7.964-2.058-13.848,0,0-23,24.163-25.373,26.335-8.126,7.449-15.944,5.372-19.573,2.133-10.16-9.066.27-20.759.27-20.759l38.746-44.407a19.283,19.283,0,0,1,10.069-6.138c4.131-.975,8.3-1.472,8.3-1.472l25.871.22a43.435,43.435,0,0,1,7.708.943s8.978,2.884,11.3,14S642.726,269.1,642.726,269.1Z",
    transform: "translate(-536.275 -227.965)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    transform: "translate(102.011 23.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M604.177,242.3a10.439,10.439,0,0,1,.158,2.151c.034,1.386.008,3.393-.14,5.868a156.106,156.106,0,0,1-2.553,19.182c-.487,2.534-1,4.971-1.531,7.231l.01-.08c-.228,5.764-.456,10.748-.653,14.289-.1,1.648-.192,3.027-.265,4.149a6.107,6.107,0,0,1-.191,1.492,6.145,6.145,0,0,1-.086-1.5c.008-1.125.016-2.508.028-4.159.052-3.546.174-8.534.352-14.3l0-.037.01-.042c.51-2.242,1.008-4.68,1.491-7.2,1.412-7.4,2.35-14.156,2.789-19.07.223-2.455.34-4.448.407-5.827A10.507,10.507,0,0,1,604.177,242.3Z",
    transform: "translate(-598.926 -242.302)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582",
    transform: "translate(107.511 43.287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M602.306,254.557c.134-.194,6.2,3.773,13.545,8.856s13.2,9.364,13.065,9.556-6.2-3.773-13.547-8.858S602.172,254.749,602.306,254.557Z",
    transform: "translate(-602.304 -254.55)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585",
    transform: "translate(41.971 14.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M579.624,236.7c.02-.021.15.078.381.287a7.749,7.749,0,0,1,.923,1.008,11.231,11.231,0,0,1,2.006,4.6,15.174,15.174,0,0,1-.422,7.435,30.272,30.272,0,0,1-4.163,8.089,28.98,28.98,0,0,1-3.06,3.6c-1.078,1.1-2.231,2-3.24,2.919-2.052,1.838-3.822,3.584-5.285,5.072s-2.615,2.726-3.413,3.581a8.182,8.182,0,0,1-1.3,1.283,7.06,7.06,0,0,1,1.045-1.5c.725-.923,1.814-2.227,3.229-3.777s3.152-3.351,5.194-5.238c1.019-.959,2.151-1.866,3.177-2.928a29.213,29.213,0,0,0,2.962-3.509,31.086,31.086,0,0,0,4.1-7.829,15.118,15.118,0,0,0,.578-7.089A13.3,13.3,0,0,0,579.624,236.7Z",
    transform: "translate(-562.052 -236.693)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587",
    transform: "translate(50.907 69.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M567.54,280.824l.857-9.968H619l-.274,7.788Z",
    transform: "translate(-567.54 -270.856)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590",
    transform: "translate(9.475 51.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M542.094,259.462",
    transform: "translate(-542.094 -259.462)",
    fill: "none",
    stroke: "#839198",
    strokeMiterlimit: 10,
    strokeWidth: 0.05
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_593",
    "data-name": "Group 593",
    transform: "translate(1.127 50.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_591",
    "data-name": "Group 591"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M543.576,258.709c.093.127-1.278.957-2.806,2.929a13.487,13.487,0,0,0,.72,17.681c1.68,1.843,3.115,2.56,3.032,2.693-.023.046-.4-.083-1.034-.43a11.5,11.5,0,0,1-2.431-1.846,13.382,13.382,0,0,1-.751-18.477,11.508,11.508,0,0,1,2.273-2.037C543.182,258.824,543.548,258.665,543.576,258.709Z",
    transform: "translate(-536.967 -258.702)",
    fill: "#455a64"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597",
    transform: "translate(106.099 429.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M608.484,445.883l5.739,13.352-25.681-.306L588,445.319Z",
    transform: "translate(-587.999 -445.319)",
    fill: "#ad5fb5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595",
    transform: "translate(0.353 10.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M588.216,452.415a23.515,23.515,0,0,0,3.6.184c2.224.037,5.3.026,8.685-.028l8.67-.181a26.97,26.97,0,0,0,3.592-.181,23.861,23.861,0,0,0-3.6-.176c-2.224-.036-5.3-.023-8.685.033l-8.669.174A27.107,27.107,0,0,0,588.216,452.415Z",
    transform: "translate(-588.216 -452.014)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596",
    transform: "translate(10.853 0.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M594.87,445.487c-.225.013-.272,2.438-.108,5.417s.48,5.385.705,5.372.273-2.437.107-5.417S595.095,445.476,594.87,445.487Z",
    transform: "translate(-594.665 -445.487)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M614.048,455.309l-25.668-.86-.164-2.435,24.542.21,1.3,2.795",
    transform: "translate(-587.864 -441.114)",
    fill: "#fff",
    opacity: 0.6
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_607",
    "data-name": "Group 607",
    transform: "translate(4.671 153.408)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_600",
    "data-name": "Group 600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_599",
    "data-name": "Group 599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M658.285,297.623c19.321,60.979-5.586,135,.386,206.049.588,6.98,3.421,15.332-3.107,19.306a10.668,10.668,0,0,1-5.891,1.438c-5.217-.171-9.574-2.877-14.231-4.735a42.286,42.286,0,0,0-28-1.086c-6.165,1.923-12.277,5.319-18.663,4.354C580.3,521.667,574.8,513.285,567,509.734c-7.308-3.325-15.747-2.086-23.771-2.286l-.241-.007a18.01,18.01,0,0,1-16.633-22.807c11.663-42.717,50.345-181.482,67.468-206.816l51.19-2.179C649.729,281.34,655.791,289.855,658.285,297.623Z",
    transform: "translate(-525.707 -275.64)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603",
    transform: "translate(91.317 50.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_601",
    "data-name": "Group 601"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M605.118,306.772a22.664,22.664,0,0,1-2.784,3.5A79.893,79.893,0,0,1,594.777,318a50.785,50.785,0,0,1-8.919,6.134,19.505,19.505,0,0,1-4.064,1.881c-.174-.295,6.083-3.206,12.428-8.656,3.146-2.742,5.741-5.525,7.671-7.49A24.065,24.065,0,0,1,605.118,306.772Z",
    transform: "translate(-581.79 -306.769)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606",
    transform: "translate(61.835 73.699)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_605",
    "data-name": "Group 605"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M593.89,320.9a218.115,218.115,0,0,0-8.576,130.52c.917,3.727,1.856,7.964-.267,11.162-2.748,4.142-9.4,3.856-13.161.607s-5.264-8.361-6.207-13.243c-7.028-36.38,5.7-72.937,19.449-107.344",
    transform: "translate(-563.683 -320.903)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsgirl);
export default __webpack_public_path__ + "static/media/Statsgirl.d61f7d582485542c5a804525835eae71.svg";
export { ForwardRef as ReactComponent };